import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { maintenanceAPI } from 'api/MaintenanceAPI'
import { useState, useEffect } from 'react'
import { IMaintenance } from 'types/maintenanceInterfaces'
import { chooseDBTranslation } from 'utils/translations'
import { useTranslation } from 'react-i18next'

const MaintenanceAlert: React.FC = () => {
  const { i18n } = useTranslation()
  const [maintenance, setMaintenance] = useState<IMaintenance[]>([])

  useEffect(() => {
    const checkMaintenance = async () => {
      const results = await maintenanceAPI.getMaintenanceStatus()
      setMaintenance(results)
    }

    checkMaintenance()

    const interval = setInterval(checkMaintenance, 10 * 60 * 1000)

    return () => clearInterval(interval)
  }, [])

  if (maintenance.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        px: 2,
        py: 1,
      }}
    >
      <Alert
        sx={{
          width: 'min(900px, 100%)',
          alignItems: 'center',
          backgroundColor: '#fff8e1',
          color: '#5f4300',
          '& .MuiAlert-icon': {
            color: '#8a5a00',
          },
        }}
        severity="warning"
      >
        {maintenance.map(
          (item, index) =>
            item.enabled &&
            ((!item.startAt && !item.endAt) ||
              (item.startAt &&
                item.endAt &&
                new Date(item.startAt) <= new Date() &&
                new Date(item.endAt) >= new Date()) ||
              (item.startAt && !item.endAt && new Date(item.startAt) <= new Date())) && (
              <div key={item.id}>
                <Typography>{chooseDBTranslation(i18n, item).message}</Typography>
                {index < maintenance.length - 1 && <hr />}
              </div>
            )
        )}
      </Alert>
    </Box>
  )
}

export default MaintenanceAlert
